import { SelectOption } from '~globals/types/commons';
import {
  ItemStateTypes,
  RouteItemStateType,
  CollectItemStateTypes,
  PickingStateTypes,
} from '~globals/types/enums';

export const ORDERS_PENDING_STATE_OPTIONS: SelectOption[] = [
  { value: ItemStateTypes.New, label: 'Recepcionado' },
  { value: ItemStateTypes.ToValidate, label: 'A Colectar' },
  { value: ItemStateTypes.Validated, label: 'Colectado' },
];

export const ORDERS_ON_AGENDA_STATE_OPTIONS: SelectOption[] = [
  { value: RouteItemStateType.OnAgenda, label: 'A Despachar' },
  { value: RouteItemStateType.InProgress, label: 'En viaje' },
];

export const ORDERS_FINALIZED_STATE_OPTIONS: SelectOption[] = [
  { value: RouteItemStateType.FinalizedSuccess, label: 'Completa' },
  { value: RouteItemStateType.FinalizedError, label: 'Incompleta' },
  { value: RouteItemStateType.WithoutVisiting, label: 'Cierre forzoso' },
];

export const IN_WAREHOUSE_STATE_OPTIONS: SelectOption[] = [
  { value: RouteItemStateType.New, label: 'Recepcionado' },
  { value: RouteItemStateType.OnAgenda, label: 'A Despachar' },
];

export const COLLECT_STATE_OPTIONS: SelectOption[] = [
  { value: CollectItemStateTypes.ToCollect, label: 'A colectar' },
  { value: CollectItemStateTypes.Validated, label: 'Colectado' },
];

export const PICKING_STATE_OPTIONS: SelectOption[] = [
  { value: PickingStateTypes.NotApplicable, label: 'No aplica' },
  { value: PickingStateTypes.ToPicking, label: 'A Picking' },
  { value: PickingStateTypes.ToLabel, label: 'A Etiquetar' },
  { value: PickingStateTypes.ToDispatch, label: 'A Despachar' },
  { value: PickingStateTypes.Dispatched, label: 'Despachado' },
];

export const ITEM_STATE_KEY = 'itemState';

export const ROUTE_ITEM_STATE_KEY = 'routeItemState';

export const ORDERS_GLOBALS_OPTIONS: SelectOption[] = [
  {
    label: 'Recepcionado',
    value: `${ITEM_STATE_KEY}-${ItemStateTypes.New}`,
  },
  {
    label: 'A Colectar',
    value: `${ITEM_STATE_KEY}-${ItemStateTypes.ToValidate}`,
  },
  {
    label: 'Colectado',
    value: `${ITEM_STATE_KEY}-${ItemStateTypes.Validated}`,
  },
  {
    label: 'A Despachar',
    value: `${ROUTE_ITEM_STATE_KEY}-${RouteItemStateType.OnAgenda}`,
  },
  {
    label: 'En viaje',
    value: `${ROUTE_ITEM_STATE_KEY}-${RouteItemStateType.InProgress}`,
  },
  {
    label: 'Completa',
    value: `${ROUTE_ITEM_STATE_KEY}-${RouteItemStateType.FinalizedSuccess}`,
  },
  {
    label: 'Incompleta',
    value: `${ROUTE_ITEM_STATE_KEY}-${RouteItemStateType.FinalizedError}`,
  },
  {
    label: 'Cierre forzoso',
    value: `${ROUTE_ITEM_STATE_KEY}-${RouteItemStateType.WithoutVisiting}`,
  },
];

export const ORDERS_GLOBALS_OPTIONS_WITHOUT_COLLECT: SelectOption[] = [
  {
    label: 'Recepcionado',
    value: RouteItemStateType.New,
  },
  {
    label: 'A Despachar',
    value: RouteItemStateType.OnAgenda,
  },
  {
    label: 'En viaje',
    value: RouteItemStateType.InProgress,
  },
  {
    label: 'Completa',
    value: RouteItemStateType.FinalizedSuccess,
  },
  {
    label: 'Incompleta',
    value: RouteItemStateType.FinalizedError,
  },
  {
    label: 'Cierre forzoso',
    value: RouteItemStateType.WithoutVisiting,
  },
];

export const ORDERS_GLOBALS_OPTIONS_WITHOUT_COLLECT_AND_WITHOU_VISITINS: SelectOption[] =
  [
    {
      label: 'Recepcionado',
      value: RouteItemStateType.New,
    },
    {
      label: 'A Despachar',
      value: RouteItemStateType.OnAgenda,
    },
    {
      label: 'En viaje',
      value: RouteItemStateType.InProgress,
    },
    {
      label: 'Completa',
      value: RouteItemStateType.FinalizedSuccess,
    },
    {
      label: 'Incompleta',
      value: RouteItemStateType.FinalizedError,
    },
  ];
